import { render, staticRenderFns } from "./ConsumerManage.vue?vue&type=template&id=56238f42&scoped=true"
import script from "./ConsumerManage.vue?vue&type=script&lang=js"
export * from "./ConsumerManage.vue?vue&type=script&lang=js"
import style0 from "./ConsumerManage.vue?vue&type=style&index=0&id=56238f42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56238f42",
  null
  
)

export default component.exports